import { call, put, takeEvery, all, delay, fork } from "redux-saga/effects"
import {
  ViewLOBAPI,
  DeleteLOBAPI,
  CreateLOBAPI,
  UpdateLOBAPI,
  ViewSubLOBAPI,
  CreateSubLOBAPI,
  UpdateSubLOBAPI,
  DeleteSubLOBAPI,
  ViewInsuranceCompanyAPI,
  createInsuranceCompanyAPI,
  DeleteInsuranceCompanyAPI,
  UpdateInsuranceCompanyAPI,
} from "./api"
import * as types from "./constant"
import {
  getLOBSuccess,
  getLOBFail,
  UpdateLOBFail,
  UpdateLOBSuccess,
  DeleteLOBSuccess,
  DeleteLOBFail,
  CreateLOBSuccess,
  CreateLOBFail,
} from "./action"

import {
  getSubLOBSuccess,
  getSubLOBFail,
  CreateSubLOBSuccess,
  CreateSubLOBFail,
  UpdateSubLOBSuccess,
  UpdateSubLOBFail,
  DeleteSubLOBFail,
  DeleteSubLOBSuccess,
} from "./subLobaction"

import {
  getINSCOMPANYFail,
  getINSCOMPANYSuccess,
  CreateINSCOMPANYFail,
  CreateINSCOMPANYSuccess,
  DeleteINSCOMPANYFail,
  DeleteINSCOMPANYSuccess,
  UpdateINSCOMPANYFail,
  UpdateINSCOMPANYSuccess,
} from "./InsuranceAction"

function* SuperAdminLOBFunc() {
  function* getLobAsync() {
    try {
      const response = yield call(ViewLOBAPI)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getLOBFail(error))
    }
  }

  function* getLobAsyncFunc() {
    yield takeEvery(types.GET_SU_LOB_START, getLobAsync)
  }

  // CREATE LOB :-)
  function* createLOBAsync(payload) {
    try {
      const response = yield call(CreateLOBAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(CreateLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(CreateLOBFail(error))
    }
  }

  function* createLobAsyncFunc() {
    yield takeEvery(types.CREATE_SU_LOB_START, createLOBAsync)
  }

  // UPDATE LOB :-)
  function* updateLOBAsync(payload) {
    try {
      const response = yield call(UpdateLOBAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(UpdateLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(UpdateLOBFail(error))
    }
  }

  function* updateLobAsyncFunc() {
    yield takeEvery(types.UPDATE_SU_LOB_START, updateLOBAsync)
  }
  //DELETE LOB :
  function* DeleteLobAsync(payload) {
    try {
      const response = yield call(DeleteLOBAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(DeleteLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(DeleteLOBFail(error))
    }
  }

  function* DeleteLobAsyncFunc() {
    yield takeEvery(types.DEL_SU_LOB_START, DeleteLobAsync)
  }

  // ------------------- SUB LOB -----------------------------

  function* getSubLobAsync() {
    try {
      const response = yield call(ViewSubLOBAPI)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getSubLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getSubLOBFail(error))
    }
  }

  function* getSubLobAsyncFunc() {
    yield takeEvery(types.GET_SU_SUB_LOB_START, getSubLobAsync)
  }

  // CREATE LOB :-)
  function* createSubLOBAsync(payload) {
    try {
      const response = yield call(CreateSubLOBAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(CreateSubLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(CreateSubLOBFail(error))
    }
  }

  function* createSubLobAsyncFunc() {
    yield takeEvery(types.CREATE_SU_SUB_LOB_START, createSubLOBAsync)
  }

  // UPDATE LOB :-)
  function* updateSubLOBAsync(payload) {
    try {
      const response = yield call(UpdateSubLOBAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(UpdateSubLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(UpdateSubLOBFail(error))
    }
  }

  function* updateSubLobAsyncFunc() {
    yield takeEvery(types.UPDATE_SU_SUB_LOB_START, updateSubLOBAsync)
  }
  //DELETE LOB :
  function* DeleteSubLobAsync(payload) {
    try {
      const response = yield call(DeleteSubLOBAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(DeleteSubLOBSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(DeleteSubLOBFail(error))
    }
  }

  function* DeleteSubLobAsyncFunc() {
    yield takeEvery(types.DEL_SU_SUB_LOB_START, DeleteSubLobAsync)
  }

  //INSURANCE COMPANY :0
  function* getInsCompanyAsync() {
    try {
      const response = yield call(ViewInsuranceCompanyAPI)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(getINSCOMPANYSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getINSCOMPANYFail(error))
    }
  }

  function* getInsCompanyAsyncFunc() {
    yield takeEvery(types.GET_INSURANCE_COMPANY_START, getInsCompanyAsync)
  }

  // CREATE InsCompany :-)
  function* createInsCompanyAsync(payload) {
    try {
      const response = yield call(createInsuranceCompanyAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(CreateINSCOMPANYSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(CreateINSCOMPANYFail(error))
    }
  }

  function* createInsCompanyAsyncFunc() {
    yield takeEvery(types.CREATE_INSURANCE_COMPANY_START, createInsCompanyAsync)
  }

  // UPDATE InsCompany :-)
  function* updateInsCompanyAsync(payload) {
    try {
      const response = yield call(UpdateInsuranceCompanyAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(UpdateINSCOMPANYSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(UpdateINSCOMPANYFail(error))
    }
  }

  function* updateInsCompanyAsyncFunc() {
    yield takeEvery(types.UPDATE_INSURANCE_COMPANY_START, updateInsCompanyAsync)
  }
  //DELETE InsCompany :
  function* DeleteInsCompanyAsync(payload) {
    try {
      const response = yield call(DeleteInsuranceCompanyAPI, payload)
      if (response.status === 200 || 201) {
        delay(500)
        yield put(DeleteINSCOMPANYSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(DeleteINSCOMPANYFail(error))
    }
  }

  function* DeleteInsCompanyAsyncFunc() {
    yield takeEvery(types.DEL_INSURANCE_COMPANY_START, DeleteInsCompanyAsync)
  }
  yield all([
    fork(getLobAsyncFunc),
    fork(createLobAsyncFunc),
    fork(updateLobAsyncFunc),
    fork(DeleteLobAsyncFunc),
    fork(getSubLobAsyncFunc),
    fork(createSubLobAsyncFunc),
    fork(updateLobAsyncFunc),
    fork(DeleteSubLobAsyncFunc),
    fork(updateSubLobAsyncFunc),
    fork(createInsCompanyAsyncFunc),
    fork(updateInsCompanyAsyncFunc),
    fork(DeleteInsCompanyAsyncFunc),
    fork(getInsCompanyAsyncFunc),
  ])
}

export default SuperAdminLOBFunc
